var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-card event-card-1 clearfix",
      class: [_vm.theme, "direction-" + _vm.direction],
    },
    [
      !_vm.verticalMode
        ? _c(
            "a",
            {
              staticClass: "event-image",
              class: { "event-image-square": _vm.useSquareImages },
              style: {
                "background-image":
                  "url('" +
                  _vm.getImageUrl(
                    _vm.event.primaryImage
                      ? _vm.event.primaryImage.medium
                      : null
                  ) +
                  "')",
              },
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.onEventClick($event)
                },
                load: _vm.imgLoaded,
              },
            },
            [
              _c("div", { staticClass: "event-card-cover" }, [
                _c("div", { staticClass: "event-card-text" }, [
                  _c("p", { staticClass: "event-name" }, [
                    _vm._v(_vm._s(_vm.event.name)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "event-date" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUTCDate")(
                          _vm.event.date,
                          "dddd MMMM Do, YYYY"
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.verticalMode
        ? _c(
            "a",
            {
              staticClass: "event-image event-image-vertical-mode",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.onEventClick($event)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.getImageUrl(
                    _vm.event.primaryImage
                      ? _vm.event.primaryImage.medium
                      : null
                  ),
                },
                on: { load: _vm.imgLoaded },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "event-card-cover" }, [
                _c("div", { staticClass: "event-card-text" }, [
                  _c("p", { staticClass: "event-name" }, [
                    _vm._v(_vm._s(_vm.event.name)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "event-date" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUTCDate")(
                          _vm.event.date,
                          "dddd MMMM Do, YYYY"
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      style: {
                        "background-color": _vm.buttonBgColorSanitized,
                        "border-color": _vm.buttonBgColorSanitized,
                        color: _vm.buttonTextColorSanitized,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.onEventClick($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.buttonText) + "\n        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/EventCard1/template.html?vue&type=template&id=0de026cc&
// module id = 1043
// module chunks = 0